<div class="product-content-div">
    <br>
    <section id="tabs" class="project-tab ipad-pro">
        <div class="container">
            <div class="row pl-3">
                <div class="col-lg-4 tabDiv">
                    <nav class="product-tab">
                        <div class="nav nav-tabs nav-fill pe-auto" id="nav-tab" role="tablist">
                            <div class="tab-bar" >{{ 'home.productHeader.Browseby' | cxTranslate }}:</div>
                            <div class="nav-item nav-link active tab-bar strong " id="nav-home-tab" data-toggle="tab" href="#nav-by-port" role="tab" aria-controls="nav-home" aria-selected="true" (click)="refreshCarousel('port')">{{ 'home.productHeader.Ports' | cxTranslate }}</div>
                            <div class="nav-item nav-link tab-bar strong " id="nav-profile-tab" data-toggle="tab" href="#nav-by-product" role="tab" aria-controls="nav-profile" aria-selected="false" (click)="refreshCarouselProduct('product')">{{ 'home.headerLinks.material' | cxTranslate }}</div>
                            <div class="nav-item nav-link tab-bar strong " id="nav-contact-tab" data-toggle="tab" href="#nav-all" role="tab" (click)="refreshCarouselAll('all')" aria-controls="nav-contact" aria-selected="false"><span class="visible-xs strong">{{ 'home.productHeader.All' | cxTranslate }}</span> <span class="hidden-xs strong">{{ 'home.productHeader.All' | cxTranslate }}</span> </div>
                        </div>
                    </nav>
                </div>
                <div class="col-md-8 mobdisplay gird-div display-top mt-n1 visible-xs-filter-bar" style="float: right !important;">
                    <span class="grid-icon">{{ 'home.productHeader.Display' | cxTranslate }}<img class="grid-icon"
              (click)="viewGrid()" [src]='gridSrc'>
            <img class="list-icon" (click)="viewList()" [src]='listSrc'></span>
                    <span *ngIf="false" class="grid-icon css-sort">{{ 'home.productHeader.sortBy' | cxTranslate }} :

            <select class="dropdownClass" (change)="selectChangeHandler($event)">
              <option value="relevance">Relevance</option>
              <option value="name-asc">A-Z</option>
              <option value="name-desc">Z-A</option>
              <option value="topRated">Popularity</option>
              <option value="price-asc">Low to High</option>
              <option value="price-desc">High to Low </option>
            </select>
          </span>
                </div>
            </div>
        </div>
        <hr>
        <!-- content area -->
        <div class="tab-content" id="nav-tabContent">
            <div class="tab-pane fade show active" id="nav-by-port" role="tabpanel" aria-labelledby="nav-home-tab">
                <app-custom-ports-content *ngIf="this.activeTab === 'port'" [list]="list" [grid]="grid" [sortData]="selectedSort"></app-custom-ports-content>
            </div>
            <div class="tab-pane fade" role="tabpanel" id="nav-by-product" aria-labelledby="nav-profile-tab">
                <app-custom-product-type-content *ngIf="this.activeTab === 'product'" [list]="list" [grid]="grid" [sortData]="selectedSort">
                </app-custom-product-type-content>
            </div>
            <div class="tab-pane fade" role="tabpanel" id="nav-all" aria-labelledby="nav-contact-tab">
                <div class="container">
                    <app-custom-products-browse-all-content *ngIf="this.activeTab === 'all'" [list]="list" [grid]="grid" [sortData]="selectedSort"></app-custom-products-browse-all-content>
                </div>
            </div>
        </div>
    </section>
</div>